/* eslint-disable no-unused-vars */
import axios from 'axios';
import { store } from '../store';
import api from './api';

// Utilities
import formatDispositionNumToString from '../utils/format-disposition';

function remapShoppers(shopperList) {
  return shopperList.map((shopper) => ({
    campaigns: shopper.campaign_names,
    city: shopper.city,
    county: shopper.county,
    county_name: shopper.county_name,
    created: shopper.created,
    first_name: shopper.first_name,
    lead_id: shopper.lead_id,
    last_name: shopper.last_name,
    last_updated: shopper.last_updated,
    lead_opened: shopper.lead_opened,
    lead_type: shopper.lead_type,
    lead_status: shopper.lead_status,
    lead_source: shopper.lead_source,
    state: shopper.state,
    username: shopper.username,
    zip: shopper.zipcode,
    soa_count: shopper.soa_count || 0,
    enrollment_count: shopper.enrollment_count || 0,
    agent_combined_name: shopper.agent_combined_name,
    agent_email: shopper.agent_email,
    agent_first_name: shopper.agent_first_name,
    agent_last_name: shopper.agent_last_name,
    agent_npn: shopper.agent_npn,
    agent_username: shopper.agent_username,
    address: shopper.address,
    data: shopper.data || {},
  }));
}

export function loadShoppers({
  agentUsername,
  desc,
  page,
  searchTerm,
  sortTerm,
}) {
  const { token } = store.getState().auth;
  return axios({
    url: `${process.env.REACT_APP_MMB_API_URL}/api/supervisor/shopper/search/${agentUsername}/`,
    method: 'get',
    headers: { Authorization: `Token ${token}` },
    params: {
      sort: sortTerm,
      lead_search: searchTerm,
      page,
      desc,
    },
  }).then(({ data }) => {
    const mappedShoppers = remapShoppers(data.Users);
    const payload = {
      totalShoppers: data.TotalUsers,
      page: data.Page,
      pageSize: data.MaxPageSize,
      totalPages: data.TotalPages,
      shopperList: mappedShoppers,
    };
    return payload;
  });
}

export function loadAllShoppers({
  agentUsername = '*',
  desc,
  page,
  searchTerm,
  sortTerm,
  dispositionFilter,
}) {
  const { token } = store.getState().auth;
  return axios({
    url: `${process.env.REACT_APP_MMB_API_URL}/api/supervisor/shopper/search/${agentUsername}/`,
    method: 'get',
    headers: { Authorization: `Token ${token}` },
    params: {
      sort: sortTerm,
      lead_search: searchTerm,
      lead_status: dispositionFilter,
      page,
      desc,
    },
  }).then(({ data }) => {
    const mappedShoppers = remapShoppers(data.Users);
    const payload = {
      totalShoppers: data.TotalUsers,
      page: data.Page,
      pageSize: data.MaxPageSize,
      totalPages: data.TotalPages,
      shopperList: mappedShoppers,
    };
    return payload;
  });
}

export function remapAPIShopper(apiShopper) {
  const data = apiShopper;
  const rfmData = {
    created: data.created || '',
    city: data.city || '',
    county: data.county || '',
    countyName: data.county_name || '',
    firstName:
      data.first_name.charAt(0).toUpperCase()
      + data.first_name.slice(1).toLowerCase() || '',
    lastName: data.last_name || '',
    lastUpdated: data.last_updated || '',
    leadID: data.lead_id || '',
    leadSource: data.lead_source || '',
    leadStatus: data.lead_status || '',
    leadType: data.lead_type || '',
    state: data.state.toUpperCase() || '',
    username: data.username || '',
    zip: data.zipcode || '',
  };
  return rfmData;
}

export function updateShopper(shopper, { mobile = false } = {}) {
  const { token } = store.getState().auth;
  const rfmData = {
    lead_id: shopper.leadID,
    lead_type: shopper.leadType,
    lead_source: shopper.leadSource,
    lead_status: shopper.leadStatus ? Number(shopper.leadStatus) : undefined,
  };
  return new Promise((resolve, reject) => {
    axios({
      url: `${process.env.REACT_APP_MMB_API_URL}/api/agent/shopper/${shopper.username}/`,
      method: 'put',
      headers: { Authorization: `Token ${token}` },
      params: { mobile },
      data: rfmData,
    })
      .then((res) => {
        const updateData = remapAPIShopper(res.data);
        store.dispatch({ type: 'UPDATE_SHOPPER', payload: updateData });
        resolve(updateData);
      })
      .catch((err) => {
        if (err.response && err.response.status === 409) {
          reject(new Error('Whoops! This email is already associated with another account'));
        } else if (err.response && err.response.data && err.response.data.error) {
          reject(err.response.data.error);
        }
        reject(err);
      });
  });
}

export const updateStatus = (shopper) => new Promise((resolve, reject) => {
  api({
    method: 'put',
    url: `/agent/shopper/${shopper.username}/`,
    data: {
      lead_id: shopper.lead_id,
      lead_status: shopper.lead_status ? Number(shopper.lead_status) : undefined,
    },
  })
    .then((data) => {
      resolve(data);
    })
    .catch((err) => {
      if (err.response && err.response.status === 409) {
        reject(new Error('Whoops! This email is already associated with another account'));
      } else if (err.response && err.response.data && err.response.data.error) {
        reject(err.response.data.error);
      }
      reject(err);
    });
});

export function reassignShoppers({ leadIDs, agentUsername }) {
  const { token } = store.getState().auth;
  const rfmData = {
    lead_ids: leadIDs,
    agent_username: agentUsername,
  };
  return axios({
    url: `${process.env.REACT_APP_MMB_API_URL}/api/supervisor/leads/reassign/`,
    method: 'post',
    headers: { Authorization: `Token ${token}` },
    data: rfmData,
  }).then((res) => res.data);
}
